import Icon from "./Icon";
import IconBadge from "./IconBadge";

export { Icon, IconBadge };
